import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "ds_lang";

const detectDefault = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "fr" || saved === "en") return saved;
  } catch (e) {
    /* ignore */
  }
  const nav =
    typeof navigator !== "undefined"
      ? navigator.language || navigator.userLanguage || "fr"
      : "fr";
  return nav.toLowerCase().startsWith("en") ? "en" : "fr";
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* ignore */
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "fr");
  const toggle = () => setLangState((p) => (p === "fr" ? "en" : "fr"));

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
